export const blockIconsHouseholdChairNew = (
	<span className='material-symbols-outlined'>chair</span>
);
